
import Page from './common/page';

class Observer {
    constructor() {
        this.$el = $('.page-title--empty-space');

        window.addEventListener('scroll', this.Callbacks.bind(this))
    }

    Callbacks(){

        if( document.documentElement.scrollTop < (window.innerHeight * 0.5) ){
            this.$el.addClass('page-title--vertical-line--show');
            $('.up-to__btn').removeClass('up-to__btn__show')
        }
        if(document.documentElement.scrollTop > (window.innerHeight * 0.5) ){
            this.$el.removeClass('page-title--vertical-line--show');
            $('.up-to__btn').addClass('up-to__btn__show')
        }
        
        if(document.documentElement.scrollTop < 4){
            $('.header').css('box-shadow','none')
        }

        $('.header').css('box-shadow','2px 4px 16px -3px rgba(39, 136, 251, 0.16)')
    }
}

class ObserverForPages extends Page {
    init() {
        this.observer = new Observer;
    }
}

export default ObserverForPages;
